import { useTranslation } from "react-i18next";

export default function AboutSection() {
  const { t } = useTranslation();

  const features = [
    { icon: "ri-award-line", key: "about_feat1" },
    { icon: "ri-bank-line", key: "about_feat2" },
    { icon: "ri-global-line", key: "about_feat3" },
    { icon: "ri-lock-line", key: "about_feat4" },
  ];

  return (
    <section id="about" className="py-14 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="relative">
            <div className="rounded-2xl overflow-hidden w-full h-56 sm:h-72 md:h-[480px]">
              <img
                alt="GPFG Office"
                className="w-full h-full object-cover object-top"
                src="https://public.readdy.ai/ai/img_res/73c70371079a33b7eaa7639a69da5926.jpg"
              />
            </div>
            <div className="hidden sm:block absolute -bottom-5 -right-3 md:-bottom-6 md:-right-6 bg-emerald-700 text-white rounded-2xl p-4 md:p-6 max-w-[160px] md:max-w-[200px]">
              <div className="text-2xl md:text-3xl font-bold">35+</div>
              <div className="text-xs md:text-sm text-emerald-200 mt-1">{t("about_years")}</div>
            </div>
          </div>

          <div className="mt-4 sm:mt-8 lg:mt-0">
            <div className="inline-flex items-center gap-2 bg-emerald-50 text-emerald-700 text-xs font-semibold px-4 py-2 rounded-full mb-5">
              <i className="ri-information-line"></i>
              {t("about_badge")}
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-5 leading-tight">
              {t("about_title_1")} <span className="text-emerald-700">{t("about_title_2")}</span>
            </h2>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-4">
              {t("about_desc1")}
            </p>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-6">
              {t("about_desc2")}
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-7">
              {features.map((item) => (
                <div key={item.key} className="flex items-center gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-emerald-50 text-emerald-700 flex-shrink-0">
                    <i className={item.icon}></i>
                  </div>
                  <span className="text-gray-700 text-sm font-medium">{t(item.key)}</span>
                </div>
              ))}
            </div>
            <a
              href="#pension-options"
              className="inline-block bg-emerald-700 hover:bg-emerald-800 text-white font-semibold px-7 py-3.5 rounded-full transition-colors cursor-pointer whitespace-nowrap"
            >
              {t("about_cta")}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
